import { AgentStatusType, AgentStatusTypes } from "../interfaces/agentStatus";

export const getAgentStatusType = (name: string, status: AgentStatusType): AgentStatusType => {
  if (name === 'Connected' || name === 'On Hold') {
    return AgentStatusTypes.OnCall;
  }

  if(status === AgentStatusTypes.Routable && name === 'ACW') {
    return AgentStatusTypes.ACW;
  }

  return status;
};
